
import { useEffect, useState } from "react";


const SignSdkCheck = () => {
  const [token, setToken] = useState("");
  const [sdkData, setSdkData] = useState(null);
  const [scriptUrl, setScriptUrl] = useState("");
  const [sdkReady, setSdkReady] = useState(false);

  const fetchToken = () => {
    // Replace 'YOUR_API_ENDPOINT' with the actual API endpoint to fetch the token
    const apiUrl =
      "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck";

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "Iq0wt1I0D13WeEIlItpIY39LIDFC71I16kxv6uDk"
      },
      body: JSON.stringify({ key: "PAVghLwdliiI", clientName: "Phillip_capital" }),
    };

    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setToken(data.body); // Assuming the response contains the 'token' field
      })
      .catch((error) => {
        console.error("Error fetching token:", error);
      });
  };


  const handleSDKData = (data) => {
    setSdkData(data);
  };

  // window.AinxtSDK.Initialize(token, handleSDKData);
  function myFunction() {
    let user_type = 'fresh'; // Default user_type // "fresh" or "rejected" or "dormant"
    let project_name = 'diy'; // Default project_name // "diy" or  "partner"
    let request_id = 'abc123mani'; // Default request_id 
    let IsShowBanner = false
    let language = 'english'
    let source = 'ketan'
    let commit_id = '1234'
    let isbackrequired = true
    if (!window.AinxtSDK) {
      console.error("AinxtSDK is not loaded yet. Check the script URL and wait for it to finish loading.");
      return;
    }
    window.AinxtSDK.Initialize(
      token,
      handleSDKData,
      "upload",
      "prod"
      // user_type,
      // project_name,
      // request_id,
      // IsShowBanner,
      // language,
      // source,
      // commit_id,
      // isbackrequired
    );
  }

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://d16c1ao2974uxc.cloudfront.net/hdfc_sky_sign_uat.js";
  //   script.async = true;
  //   document.head.appendChild(script);

  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);

  useEffect(() => {
    if (scriptUrl) {
      setSdkReady(false);
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => setSdkReady(true);
      script.onerror = () => console.error("Failed to load SDK script:", scriptUrl);

      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [scriptUrl]); // Dependency on scriptUrl

  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-8">Signature SDK Test</h1>
      <input
        type="text"
        placeholder="Enter Script URL"
        value={scriptUrl}
        onChange={(e) => setScriptUrl(e.target.value)}
        className="form-control"
        style={{
          padding: "10px",
          width: "300px",
          // margin: "10px auto",
          display: "block",
          borderRadius: "5px",
        }}
      />
      {
        scriptUrl && (
          <>
            {token && (
              <button
                className="mt-4 bg-green-500 hover:bg-green-700 text-dark font-bold py-2 px-4 rounded"
                onClick={myFunction}
                disabled={!sdkReady}
              >
                {sdkReady ? "Initialize AinxtSDK" : "Loading SDK..."}
              </button>
            )}
          </>
        )
      }
      <button
        className="bg-blue-500 hover:bg-blue-700 text-dark font-bold py-2 px-4 rounded"
        onClick={fetchToken}
      >
        Get Token
      </button>

      {sdkData && (
        <div className="mt-4">
          <h2 className="text-xl font-bold mb-2">Data from SDK:</h2>
          <pre className="whitespace-pre-wrap font-bold">{JSON.stringify(sdkData, null, 2)}</pre>
        </div>
      )}

    </div>
  );
};

export default SignSdkCheck;




// Phillip Capital signature sdk check


// import { useEffect, useState } from "react";


// const SignSdkCheck = () => {
//   const [token, setToken] = useState("");
//   const [sdkData, setSdkData] = useState(null);
//   const [scriptUrl, setScriptUrl] = useState("");
//   const [sdkReady, setSdkReady] = useState(false);

//   const fetchToken = () => {
//     // Replace 'YOUR_API_ENDPOINT' with the actual API endpoint to fetch the token
//     const apiUrl =
//       "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck";

//     const requestOptions = {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-api-key": "Iq0wt1I0D13WeEIlItpIY39LIDFC71I16kxv6uDk"
//       },
//       body: JSON.stringify({ key: "PAVghLwdliiI", clientName: "Phillip_capital" }),
//     };

//     fetch(apiUrl, requestOptions)
//       .then((response) => response.json())
//       .then((data) => {
//         setToken(data.body); // Assuming the response contains the 'token' field
//       })
//       .catch((error) => {
//         console.error("Error fetching token:", error);
//       });
//   };


//   const handleSDKData = (data) => {
//     setSdkData(data);
//   };

//   function myFunction() {
//     if (!window.AinxtSDKsign) {
//       console.error("AinxtSDKsign is not loaded yet. Check the script URL and wait for it to finish loading.");
//       return;
//     }
//     window.AinxtSDKsign.Initialize(token, handleSDKData);
//   }



//   useEffect(() => {
//     if (scriptUrl) {
//       setSdkReady(false);
//       const script = document.createElement("script");
//       script.src = scriptUrl;
//       script.async = true;
//       script.onload = () => setSdkReady(true);
//       script.onerror = () => console.error("Failed to load SDK script:", scriptUrl);

//       document.head.appendChild(script);

//       return () => {
//         document.head.removeChild(script);
//       };
//     }
//   }, [scriptUrl]); // Dependency on scriptUrl

//   return (
//     <div className="text-center">
//       <h1 className="text-4xl font-bold mb-8">Signature SDK Test </h1>
//       <input
//         type="text"
//         placeholder="Enter Script URL"
//         value={scriptUrl}
//         onChange={(e) => setScriptUrl(e.target.value)}
//         className="form-control"
//         style={{
//           padding: "10px",
//           width: "300px",
//           // margin: "10px auto",
//           display: "block",
//           borderRadius: "5px",
//         }}
//       />
//       {
//         scriptUrl && (
//           <>
//             {token && (
//               <button
//                 className="mt-4 bg-green-500 hover:bg-green-700 text-dark font-bold py-2 px-4 rounded"
//                 onClick={myFunction}
//                 disabled={!sdkReady}
//               >
//                 {sdkReady ? "Initialize AinxtSDK" : "Loading SDK..."}
//               </button>
//             )}
//           </>
//         )
//       }
//       <button
//         className="bg-blue-500 hover:bg-blue-700 text-dark font-bold py-2 px-4 rounded"
//         onClick={fetchToken}
//       >
//         Get Token
//       </button>

//       {sdkData && (
//         <div className="mt-4">
//           <h2 className="text-xl font-bold mb-2">Data from SDK:</h2>
//           <pre className="whitespace-pre-wrap font-bold">{JSON.stringify(sdkData, null, 2)}</pre>
//         </div>
//       )}

//     </div>
//   );
// };

// export default SignSdkCheck;

